import { hideOverlay, showOverlay, whenNotShownInOverlay } from './Overlay';
export default (() => {
    console.log('UNTUCKit : Module : VideoModal : loaded');
    const videoModal = () => document.querySelector('[data-video-modal]');
    const videoModalIframe = () => document.querySelector('[data-video-modal-iframe]');
    const openVideo = (event) => {
        const target = event.target instanceof Element ? event.target.closest('[data-video-id]') : null;
        const modal = videoModal();
        const iframe = videoModalIframe();
        if (!(target instanceof HTMLElement) || !modal || !iframe) {
            return;
        }
        const videoID = target.getAttribute('data-video-id');
        const sourceURI = `https://www.youtube.com/embed/${videoID}/?rel=0;&autoplay=1`;
        modal.classList.add('is-active');
        iframe.setAttribute('src', sourceURI);
        showOverlay('video');
    };
    const closeVideo = () => {
        const modal = videoModal();
        if (!modal?.classList.contains('is-active')) {
            return;
        }
        hideOverlay();
        modal.classList.remove('is-active');
        videoModalIframe()?.setAttribute('src', '');
    };
    const onDocumentClick = (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }
        if (event.target.closest('[data-video-id]')) {
            openVideo(event);
            return;
        }
        if (event.target.closest('.js-close-modal')) {
            closeVideo();
        }
    };
    const bindUIActions = () => {
        document.addEventListener('click', onDocumentClick);
        whenNotShownInOverlay('video').subscribe(() => closeVideo());
    };
    const init = () => {
        console.log('UNTUCKit : Module : VideoModal : init');
        bindUIActions();
    };
    return { init };
})();
